import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { first } from 'lodash';
// import ReactTooltip from 'react-tooltip';

// import Delete from './Delete';

const Onboards = ({ place, users }) => {
  const [inactive, ,] = useState(false);

  const userArray =
    users && users.length !== 0
      ? users.filter(item => item.user_id === place.audit.updated_by)
      : [];

  const user = userArray.length !== 0 ? first(userArray) : undefined;

  if (inactive) {
    return null;
  }

  return (
    <React.Fragment>
      <td>
        <Link to={`/onboard/${place.place_id}`}>{place.place_name}</Link>
      </td>
      <td>{place.city}</td>
      <td>{place.status}</td>
      <td>{place?.listing_type}</td>
      <td>{place.sales_type}</td>
      <td>{place.form_status}</td>
      <td>{place?.claim_status}</td>
      <td>{place.sales_rep_email}</td>
      <td>{user?.display_name}</td>
      <td>{moment(place.audit.updated_at).format('lll')}</td>
    </React.Fragment>
  );
};

export default Onboards;
